'use strict';
var config = function($window,$log) {
  this.$window=$window;
  this.$log=$log;
  this.hosts={
    "localhost": {
      "serviceUrl":"http://localhost/outdoor/src/services/index.php",
      "defaultLang":"fr",
      "vis":"PCO"
    },
    "outdoor.lapetitemerveille.be": {
      "serviceUrl":"https://outdoor.lapetitemerveille.be/services/index.php",
      "defaultLang":"fr",
      "vis":"PCO"
    },
    "adventure-valley.be": {
      "serviceUrl":"https://outdoor.lapetitemerveille.be/services/index.php",
      "defaultLang":"fr",
      "vis":"PCO"
    },
    "sanglier-durbuy.be": {
      "serviceUrl":"https://outdoor.lapetitemerveille.be/services/index.php",
      "defaultLang":"fr",
      "vis":"PSD"
    },
    "sda.be": {
      "serviceUrl":"https://outdoor.lapetitemerveille.be/services/index.php",
      "defaultLang":"fr",
      "vis":"PSA"
    },
    "bigc.offer.outdoorapp.be": {
      "serviceUrl":"https://bigc.api.outdoorapp.be/services/index.php",
      "defaultLang":"fr"
    },
    "arduinnasilva.com": {
      "serviceUrl":"https://bigc.api.outdoorapp.be/services/index.php",
      "defaultLang":"fr"
    },
    "big-c.be": {
      "serviceUrl":"https://bigc.api.outdoorapp.be/services/index.php",
      "defaultLang":"fr"
    }
  };
  this.hostname=null;
  this.langs=['en','nl','fr'];
};
config.prototype.get = function(key) {
  var result="";
  if(this.hostname===null) {
    this.hostname=this.$window.location.hostname;
    if(this.hostname.match(/^www\./)) {
      this.hostname=this.hostname.substr(4);
    }
  }
  if(this.hostname in this.hosts) {
    result=this.hosts[this.hostname][key];
  } else {
    this.$log.log("ERROR: domain <"+this.hostname+"> is not configured");
  }
  return result;
};
angular.module("app").service("config",["$window","$log",config]);
